import { Controller, type Control, type FieldValues, type Path } from "react-hook-form";
import TextField from "@/components/TextField";
import Select, { type SelectProps } from "@/components/Select";
import type { NotePriority } from "@/types";
import { NotePriorityValues } from "@/types";
import { NOTE_PRIORITY_OPTIONS } from "./noteHelpers";

interface NoteInputFieldsProps<T extends FieldValues> {
  control: Control<T>;
  contentName: Path<T>;
  priorityName: Path<T>;
  priorityDropdownPlacement?: SelectProps["dropdownPlacement"];
}

export default function NoteInputFields<T extends FieldValues>({
  control,
  contentName,
  priorityName,
  priorityDropdownPlacement
}: NoteInputFieldsProps<T>) {
  return (
    <div className="flex flex-col gap-6">
      <Controller
        name={contentName}
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextField
            type="textarea"
            rows={3}
            label="Note"
            value={(value as string) || ""}
            onChangeText={onChange}
            className="w-full"
          />
        )}
      />
      <Controller
        name={priorityName}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            label="Note Priority"
            options={NOTE_PRIORITY_OPTIONS}
            value={(value as string) ?? NotePriorityValues.NONE}
            onSelect={(val) => onChange((val || NotePriorityValues.NONE) as NotePriority)}
            className="w-full"
            dropdownPlacement={priorityDropdownPlacement}
          />
        )}
      />
    </div>
  );
}
